import { ConstantsPage } from '../ConstantsPage';

export function Constants402() {
  return <ConstantsPage version="4.0.2" />;
}
